// schema
import * as ISchema from "@schema";

export const getGoalStringsFromGoals = (goals: ISchema.AffectedGoals[]) => {
  return goals.map((goal) => {
    switch (goal) {
      case ISchema.AffectedGoals.FocusTime:
        return { goal, message: "Costs you Focus Time" };
      case ISchema.AffectedGoals.Lunch:
        return { goal, message: "Over lunch for you" };
      case ISchema.AffectedGoals.WithinMeetingHours:
      case ISchema.AffectedGoals.WithinWorkingHours:
        return { goal, message: "Outside your working hours" };
      case ISchema.AffectedGoals.NoMeetingDay:
        return { goal, message: "On a no-meeting day for you" };
      case ISchema.AffectedGoals.TravelTime:
        return { goal, message: "Over your travel time" };
      case ISchema.AffectedGoals.MeetingRelief:
        return { goal, message: "Too many meetings in a row" };
      case ISchema.AffectedGoals.AttendMeeting:
      case ISchema.AffectedGoals.ConvenientMeetingTime:
      case ISchema.AffectedGoals.EmailTriage:
      case ISchema.AffectedGoals.FocusTask:
      case ISchema.AffectedGoals.PersonalObligation:
      case ISchema.AffectedGoals.PreferredWork:
      case ISchema.AffectedGoals.PrepTime:
      case ISchema.AffectedGoals.Task:
      default:
        return { goal, message: "Inconvenient for you" };
    }
  });
};

export const getIconTypeForGoal = (goal: ISchema.AffectedGoals) => {
  switch (goal) {
    case ISchema.AffectedGoals.FocusTime:
      return "error";
    case ISchema.AffectedGoals.Lunch:
    case ISchema.AffectedGoals.WithinMeetingHours:
    case ISchema.AffectedGoals.WithinWorkingHours:
    case ISchema.AffectedGoals.NoMeetingDay:
    case ISchema.AffectedGoals.TravelTime:
    case ISchema.AffectedGoals.MeetingRelief:
    case ISchema.AffectedGoals.AttendMeeting:
    case ISchema.AffectedGoals.ConvenientMeetingTime:
    case ISchema.AffectedGoals.EmailTriage:
    case ISchema.AffectedGoals.FocusTask:
    case ISchema.AffectedGoals.PersonalObligation:
    case ISchema.AffectedGoals.PreferredWork:
    case ISchema.AffectedGoals.PrepTime:
    case ISchema.AffectedGoals.Task:
    default:
      return "not-interested";
  }
};
